// Importing necessary Firebase modules 🚀
import { initializeApp, getApps } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import config from './config'; // Configuration for Firebase 🔧
import { initializeFirestore } from 'firebase/firestore';
import { connectFirestoreEmulator } from '@/lib/firebase/firebase';

const isProduction = process.env.NEXT_PUBLIC_ENV === 'production';

// Prevent multiple initializations
let firebaseApp;
if (!getApps().length) {
  firebaseApp = initializeApp(config);
} else {
  firebaseApp = getApps()[0];
}

// Accessing the Firestore database service 📚
// `ignoreUndefinedProperties` makes writes skip undefined fields instead of
// throwing. Optional fields (a post with no title, say) are routinely absent,
// and a throw mid-write leaves the UI stuck on whatever it was awaiting.
// This is the only place the client Firestore is started, so initializeFirestore
// is guaranteed to run before any getFirestore call.
const firestoreSettings = { ignoreUndefinedProperties: true };

export const db =
  isProduction || !process.env.NEXT_PUBLIC_DEV_DB_NAME
    ? initializeFirestore(firebaseApp, firestoreSettings)
    : initializeFirestore(firebaseApp, firestoreSettings, process.env.NEXT_PUBLIC_DEV_DB_NAME);

// Accessing the Firebase storage service 📦
export const storage = getStorage(firebaseApp);

// Initialize Functions and connect to emulator in development
export const functions = getFunctions(firebaseApp);

// Accessing the Firebase Auth service 🔐
export const auth = getAuth(firebaseApp);

// Only connect to emulators if explicitly enabled via environment variable
if (process.env.NEXT_PUBLIC_USE_EMULATOR === 'true') {
  console.log('Connecting to Firebase emulators...');
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export * from 'firebase/firestore';
export { signInWithCustomToken, onAuthStateChanged } from 'firebase/auth';
